import { IAccountDocument } from '@epicuro-next/data/documents';
import { IUser, UserRole } from '@epicuro-next/data/users';

export const mockUserId = 'Dogancan.Arabaci@neocles.io';
export const mockUserExternalId = '813afa65-8d6e-4cba-9e5b-881d842a0633';

export const mock: IUser = {
  id: 666,
  email: 'dogancan.arabaci@neocles.io',
  status: 0,
  isBlocked: false,
  avatarSource: 0,
  roles: ['Administrator'] as UserRole.Administrator[],
  userId: mockUserId,
  externalId: mockUserExternalId,
  displayName: 'Dogancan Arabaci',
  preferredCultureInfo: 'en-GB',
  imageLink: 'some-link',
  preferences: {
    preferredBaskets: [],
    preferredScaleSet: 'UK',
    relatedProductsFilterList: ['list1', 'list2'],
    preferredShippingOption: 'preferredShippingOptionId',
  },
  isSubscribedToAccountBaskets: false,
};

export const mockDocument: IAccountDocument = {
  accountAcceptDates: [],
  createdDateTime: 'created date time',
  documentVersionId: 3,
  id: 5,
  languages: [
    { language: 'language1', url: 'language1-url', fileType: 'txt' },
    { language: 'language2', url: 'language2-url', fileType: 'txt' },
  ],
  lastAcceptedDateTime: null as unknown as string,
  name: 'Document name',
  publishedDateTime: 'published date time',
  type: 'user terms',
};
